import apiClient from './apiClient';

let cached = null; // shared promise: single-flight + cached for the session; cleared on failure so a later call retries

/** The org's display name, once per session. The backend has only POST /api/organisation/profile
 *  (a GET 405s), so the name comes from the branding config, like reviewsApi.fetchOrgName. */
export function getOrganisationProfile() {
  if (!cached) {
    const p = apiClient.get('/api/organisation/prescription-config')
      .then((res) => ({ name: res?.data?.config?.clinic_name || null }))
      .catch((err) => { if (cached === p) cached = null; throw err; });
    cached = p;
  }
  return cached;
}

/** Sign-out: drop the cached promise so the next account re-fetches its own organisation. */
export function resetOrganisationProfile() {
  cached = null;
}
